import { VehicleOutput } from '@allocab/allocab-commons-shared-types';
import { VehicleInput } from '@allocab/allocab-driver-service-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const createVehicle = (input: VehicleInput) =>
  driverApi.post<VehicleInput, VehicleOutput>('/v1/vehicle/fleet-manager', input);

export const useCreateVehicle = () =>
  useMutation<VehicleOutput, unknown, VehicleInput>({
    mutationFn: createVehicle,
    onSuccess: vehicle => {
      queryClient.setQueryData(queryKeys.user.fetchVehicle(vehicle.id), vehicle);
      queryClient.invalidateQueries(queryKeys.user.fetchVehicles());
    },
  });
